import React from 'react';
import { Tooltip } from '@fluentui/react-components';
import { Info16Regular } from '@fluentui/react-icons';
import { formatInsightsOriginIndicator, insightsModuleAskTooltip } from '../../utils/intelligenceInsightsAskLensOrigin';
import styles from './askAi.module.css';

/**
 * Compact origin chip when Ask Lens was opened from an Intelligence Insights module.
 */
const AskLensOriginIndicator = ({ origin, className = '' }) => {
    if (!origin) return null;
    const label = origin.indicatorLabel || formatInsightsOriginIndicator(origin);
    if (!label) return null;

    return (
        <div className={`${styles.originIndicator} ${className}`.trim()} role="status">
            <Tooltip content={insightsModuleAskTooltip(origin)} relationship="description" positioning="below" withArrow>
                <button
                    type="button"
                    className={styles.originIndicatorInfoBtn}
                    aria-label="About this Intelligence Insights context">
                    <Info16Regular className={styles.originIndicatorIcon} aria-hidden />
                </button>
            </Tooltip>
            <span className={styles.originIndicatorLabel}>{label}</span>
        </div>
    );
};

export default AskLensOriginIndicator;
